import React, { Component } from "react";
import { connect } from "react-redux";
import Session from "../../utility/session";
import { loadPastUploads } from "../../Containers/Settings/actions";
import moment from "moment";
import { dateFormats } from "../../utility/enums";
import { numberWithCommas } from "../../utility/commonHelpers";
import { clearData } from "../../Containers/EmailValidation/actions";
import { CLEAR_USER_PAST_UPLOADS } from "../../common/constants";

const mapStateToProps = (state) => ({
  pastUploads: state.settingsInfo.pastUploads,
});

class UploadHistory extends Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
  }
  loadData = (page,limit) => {
    this.props.dispatch(
        loadPastUploads(Session.getItem("current_username"), page,limit)
    );
  }
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    this.loadData(1, 10)
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    this.props.dispatch(clearData(CLEAR_USER_PAST_UPLOADS))
  }
  handleScroll() {
    let winHeight = window.innerHeight;
    let scrollTop = document.documentElement.scrollTop;
    let scrollHeight = document.body.scrollHeight;
    const statsComponent = document.querySelector(".emails-stats-right");
    const emailVerification = document.querySelector(".emailVerification");
    if (statsComponent) {
      if (this.sticky == undefined)
        this.sticky = statsComponent.getBoundingClientRect().top;
      if (window.pageYOffset >= this.sticky) {
        statsComponent.classList.add("sticky");
        statsComponent.style.width =
          emailVerification.getBoundingClientRect().width / 2 + "px";
      } else if (statsComponent) {
        statsComponent.classList.remove("sticky");
        statsComponent.style.width = "";
      }
    }
    const selectedFileComponent = document.querySelector(".activeTimeline");
    if (selectedFileComponent) {
      if (this.stickyFile == undefined)
        this.stickyFile = selectedFileComponent.getBoundingClientRect().top;

      if (window.pageYOffset + 50 >= this.stickyFile) {
        selectedFileComponent.classList.add("sticky-left");
        selectedFileComponent.style.width =
          parseInt(emailVerification.getBoundingClientRect().width / 2) -
          70 +
          "px";
      } else {
        selectedFileComponent.classList.remove("sticky-left");
        selectedFileComponent.style.width = "";
      }
    }
    if (scrollHeight == winHeight + scrollTop) {
      console.log("Page Bottom load more files");
      const {
        limit,
        page,
        pages,
      } = this.props.pastUploads;
      if (pages >= page + 1) {
        console.log(`Has more triggered`)
          this.loadData(
            page+1,
            limit,
          )
      }
    }
  }
  render() {
    const pastUploads = this.props.pastUploads || [];
    return (
      <div
        role="tabpanel"
        className="tab-pane fade"
        id="tab_content4"
        aria-labelledby="profile-tab"
      >
        <span style={{ opacity: 0.5 }}>
          <i>Uploads older than 90 days will be moved here.</i>
        </span>
        <table className="data table table-striped no-margin">
          <thead>
            <tr>
              <th width="10%">Date</th>
              <th width="10%">File Name</th>
              <th width="10%">Total Emails</th>
              <th width="10%">Credits Consumed</th>
              <th width="10%">Valid</th>
              <th width="10%">Invalid</th>
              <th width="10%">Unknown Scored</th>
              <th width="10%">Unknown</th>
              <th width="10%">Invalid Format</th>
              <th width="10%">Duplicates</th>
              <th width="10%">Not Verified</th>
            </tr>
          </thead>
          <tbody>
            {this.props.pastUploads.loading && pastUploads.docs.length == 0 ? (
              ""
            ) : pastUploads.docs.length > 0 ? (
              pastUploads.docs.map((obj, index) => (
                <tr key={index}>
                  <td>
                    {new moment(obj.uploadedTime).format(
                      dateFormats.DISPLAY_DATE
                    )}
                  </td>
                  <td>
                    <p style={{cursor:"pointer"}} title={obj.fileName}>
                      {obj.fileName.split(".")[0].length > 35
                        ? obj.fileName
                            .substring(0, 35)
                            .concat(`...`)
                        : obj.fileName}
                    </p>
                  </td>
                  <td>{numberWithCommas(obj.totalEmails)}</td>
                  <td>
                    {numberWithCommas(obj.good + obj.bad + obj.unknownScored)}
                  </td>
                  <td>{numberWithCommas(obj.good)}</td>
                  <td>{numberWithCommas(obj.bad)}</td>
                  <td>{numberWithCommas(obj.unknownScored)}</td>
                  <td>{numberWithCommas(obj.unknown)}</td>
                  <td>{numberWithCommas(obj.syntaxError)}</td>
                  <td>{numberWithCommas(obj.duplicate)}</td>
                  <td>{numberWithCommas(obj.nonProcessed)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10" style={{ textAlign: "center", opacity: 0.7 }}>
                  No data archived.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default connect(mapStateToProps)(UploadHistory);



// WEBPACK FOOTER //
// ./src/components/Settings/uploadHistory.js